import produce from 'immer';
import { Reducer } from 'redux';

import { ICepState, ICepActionsType, ICepTypes } from './types';

const INITIAL_STATE: ICepState = {
  loading: false,
  cep: null,
};

const cep: Reducer<ICepState, ICepActionsType> = (
  state = INITIAL_STATE,
  action: ICepActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case ICepTypes.GET_CEP_REQUEST: {
        draft.loading = true;
        break;
      }
      case ICepTypes.GET_CEP_SUCCESS: {
        draft.loading = false;
        draft.cep = action.payload.cep;
        break;
      }
      case ICepTypes.GET_CEP_FAILURE: {
        draft.loading = false;
        draft.cep = null;
        break;
      }

      case ICepTypes.CLEAR_CEP_REQUEST: {
        draft.cep = null;
        break;
      }

      default:
    }
  });
};
export default cep;
